import React from 'react'
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material'

export interface DirectorBoardType {
  id: number
  code: string
  description: string
}

const directorBoardTypesInLutOrder: DirectorBoardType[] = [
  { id: 1, code: 'CIV', description: 'Civic Organization' },
  { id: 2, code: 'COR', description: 'Corporation' },
  { id: 3, code: 'EDU', description: 'Educational Institution' },
  { id: 4, code: 'FRA', description: 'Fraternal Organization' },
  { id: 8, code: 'GOV', description: 'Government Agency' },
  { id: 5, code: 'PRO', description: 'Professional Association' },
  { id: 6, code: 'SER', description: 'Service Organization' },
  { id: 7, code: 'OTH', description: 'Other' }
]

export const directorBoardTypeOptions = new Map<number, DirectorBoardType>(
  directorBoardTypesInLutOrder.map((type) => [type.id, type])
)

export const DirectorBoardTypeSelect: React.FC<{ value: DirectorBoardType | null, updateDirectorBoardType: (directorBoardType: DirectorBoardType | null) => void, disabled: boolean }> = ({ value, updateDirectorBoardType, disabled }) => {
  const handleChange = (value: string | number): void => {
    const selectedOption = directorBoardTypeOptions.get(value as number)
    updateDirectorBoardType(selectedOption ?? null)
  }

  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel id="director-board-type-select-label">Director Board Type</InputLabel>
      <Select
        labelId="director-board-type-select-label"
        label="Director Board Type"
        value={(value != null) ? value.id : ''}
        onChange={(event) => { handleChange(event.target.value) }}
        disabled={disabled}
        fullWidth
      >
        {Array.from(directorBoardTypeOptions.values()).map((directorBoardType) => (
          <MenuItem key={directorBoardType.id} value={directorBoardType.id}>
            {directorBoardType.description}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
